export default __webpack_public_path__ + "assets/images/bb12f8e252e245ab083746e70287a641.png";